import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const AttachedIcon = ({
  width = 20,
  height = 20,
  color = '#38383E',
  ...props
}: IconProps) => (
  <SvgComponent viewBox='0 0 20 20'
    width={width}
    height={height}
    {...props}
  >
    <mask id='mask0_6204_9966' maskUnits='userSpaceOnUse' x='2' y='2' width='16' height='16'>
      <path d='M2.5 2.5H17.5V17.5H2.5V2.5Z' fill='white' />
    </mask>
    <g mask='url(#mask0_6204_9966)'>
      <path
        d='M7.77344 12.2266V6.01563C7.77344 5.75674 7.9833 5.54688 8.24219 5.54688C8.50107 5.54688 8.71094 5.75674 8.71094 6.01563V12.2266C8.71094 12.9385 9.28807 13.5156 10 13.5156C10.7119 13.5156 11.2891 12.9385 11.2891 12.2266V6.30859C11.2891 4.78766 10.0561 3.55469 8.53516 3.55469C7.01423 3.55469 5.78125 4.78766 5.78125 6.30859V12.2266C5.78125 14.5565 7.67004 16.4453 10 16.4453C12.33 16.4453 14.2188 14.5565 14.2188 12.2266V6.01563C14.2188 5.75674 14.4286 5.54688 14.6875 5.54688C14.9464 5.54688 15.1562 5.75674 15.1562 6.01563V12.2266C15.1562 15.0743 12.8477 17.3828 10 17.3828C7.15227 17.3828 4.84375 15.0743 4.84375 12.2266V6.30859C4.84375 4.2699 6.49646 2.61719 8.53516 2.61719C10.5739 2.61719 12.2266 4.2699 12.2266 6.30859V12.2266C12.2266 13.4563 11.2297 14.4531 10 14.4531C8.77031 14.4531 7.77344 13.4563 7.77344 12.2266Z'
        fill='black'
      />
    </g>
  </SvgComponent>
);

export default AttachedIcon;
